module.exports = __webpack_public_path__ + "img/btn_lg_sign-in.09031fc.png";